import React from "react";

function PageHeader({ children }) {
  return <header className="responsive-container">{children}</header>;
}

export default PageHeader;
